module.exports = __webpack_public_path__ + "img/lemon.2f1d3bfe.svg";